/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
  margin-top: 200px;
`;

export const ProgressBarContainer = styled.div`
  width: 480px;
  margin: 64px 0 32px 0;
`;

export const MainContainer = styled.div<{ sticky: boolean }>`
  background-color: ${Colors.LightGray};
  min-height: 100%;
  padding-bottom: 40px;
  padding-top: 16px;

  h2 {
    margin: 0 20px;
    color: ${Colors.Black};
    font-weight: 700;
    background: ${Colors.White};
    padding: 16px 20px;
    box-shadow: 0 2px 8px rgba(1, 7, 36, 0.06);

    ${(props): any =>
      !!props.sticky &&
      css`
        position: sticky;
        top: 0;
        z-index: 9999;
      `}
  }

  .react-tabs {
    overflow-y: inherit;
  }
  .react-tabs__tab-panel {
    padding: 0px;
  }

  .react-tabs__tab-list {
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 9999;
    background: ${Colors.White};
    margin: 16px 20px;
    padding-top: 20px;
    border-bottom: 1px solid ${Colors.Gray};
  }

  .disabled-tab {
    color: ${Colors.Gray};
  }
`;
